var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformIosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63914 0.852661C9.66511 0.852661 9.69107 0.852661 9.7185 0.852661C9.78219 1.63942 9.48189 2.22729 9.11692 2.653C8.75881 3.07578 8.26843 3.48582 7.4753 3.4236C7.42239 2.64811 7.72319 2.10384 8.08766 1.6791C8.42569 1.28327 9.0454 0.931043 9.63914 0.852661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8155 8.94029C11.8155 8.94813 11.8155 8.95499 11.8155 8.96234C11.5926 9.6374 11.2747 10.216 10.8867 10.7529C10.5325 11.2403 10.0984 11.8963 9.32343 11.8963C8.65375 11.8963 8.20893 11.4657 7.5226 11.4539C6.79658 11.4422 6.39732 11.814 5.73352 11.9076C5.65759 11.9076 5.58166 11.9076 5.5072 11.9076C5.01976 11.837 4.62637 11.451 4.33979 11.1032C3.49473 10.0754 2.84171 8.74777 2.72021 7.04883C2.72021 6.88227 2.72021 6.71619 2.72021 6.54963C2.77165 5.33373 3.36246 4.34513 4.14775 3.86602C4.5622 3.61128 5.13194 3.39426 5.76635 3.49125C6.03823 3.53338 6.316 3.62646 6.55948 3.71856C6.79022 3.80723 7.07876 3.96449 7.35212 3.95616C7.5373 3.95077 7.7215 3.85426 7.90814 3.78617C8.45486 3.58874 8.9908 3.36241 9.69722 3.46872C10.5462 3.59707 11.1488 3.97428 11.5211 4.55627C10.8029 5.01334 10.2351 5.70212 10.3321 6.87835C10.4183 7.9468 11.0395 8.57189 11.8155 8.94029Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8913,
    height: 11.113,
    fill: "white",
    transform: "translate(0.393066 0.852661)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIosIcon);
export default __webpack_public_path__ + "static/media/platformIosIcon.07f3de2c6696a94846ed4bc350e862ef.svg";
export { ForwardRef as ReactComponent };